import Creators from 'components/Creators';
import { useEntityPageContext } from './EntityContext';

/** The creators tab. Keyed singular, unlike the tables' array dialect. */
const EntityCreators = ({ exportEntity, ...rest }) => {
    const { entityType, entityId, country, week, year, name, exportName } =
        useEntityPageContext();

    return (
        <Creators
            year={year}
            week={week}
            {...(entityType === 'brands'
                ? { brand: entityId || null, country: country?.id || null }
                : { category: entityId, country: country ? country.id : null })}
            filename={exportName('creator', { entity: exportEntity })}
            name={name}
            {...rest}
        />
    );
};

export default EntityCreators;
